import styled from 'styled-components';

const ContinueButton = styled.div`
  margin: 4% 4% 0% 4%;
`;

export default ContinueButton;
